<template>
  <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
    <v-toolbar color="primary" dark flat>
      {{ pageTitle }}
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="12" lg="3" md="5">
          <v-text-field v-model="postCode"
                        label="Пост-код"
                        :disabled="isCourierSelected || $store.getters.appIsOperatorLogin"
                        maxlength="6"
                        :counter="6"
                        :error-messages="postCodeErrorMessages"
          />
        </v-col>
        <v-col cols="12" lg="3" md="5">
          <v-select v-model="courier"
                    v-if="!$store.getters.appIsOperatorLogin"
                    :items="$store.getters.appCouriers"
                    :clearable="true"
                    :item-text="item => item"
                    :item-value="item => item"
                    label="Курьер"
                    @change="onCourierChanged"
          />
        </v-col>
        <v-col cols="12" md="2" lg="2">
          <v-btn color="success" @click="onCreateClicked">Создать</v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-snackbar v-model="hasNotAccessToRegion"
                :timeout="5000"
                :top="true"
                color="error"
    >
      У вас нет доступа к данному пост отделению
    </v-snackbar>
    <v-snackbar v-model="isCreationFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось создать пост-пакет
    </v-snackbar>
    <v-snackbar v-model="isPostIndexNotExists"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Пост отделение не существует
    </v-snackbar>
    <v-snackbar v-model="isPostIndexNotActive"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Пост отделение не активен
    </v-snackbar>
    <v-snackbar v-model="isRegionError"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось определить регион по пост-индексу
    </v-snackbar>
  </v-card>
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import {required, numeric, minLength, maxLength} from 'vuelidate/lib/validators'
import PostPackageService from '@/services/post.package.service'
import _ from 'underscore'
import Mappers from '@/mappers'
import {AllowCreatePostPackage} from "@/enums/permission";

export default {
  name: "PostPackageCreateView",
  data() {
    return {
      loading: false,
      courier: null,
      postCode: null,

      pageTitle: 'Создание нового пост-пакета',

      hasNotAccessToRegion: false,
      isPostIndexNotExists: false,
      isPostIndexNotActive: false,
      isCreationFailed: false,
      isRegionError: false,
    }
  },
  computed: {
    isCourierSelected() {
      return !!this.courier
    },
    postCodeErrorMessages() {
      const errors = []

      if (this.$v.postCode.$dirty) {
        !this.$v.postCode.required && errors.push(`Введите индекс`)

        if (this.$v.postCode.required) {
          !this.$v.postCode.numeric && errors.push(`Доступно только цифры`)
          !this.$v.postCode.minLength && errors.push(`Минимум 6 цифр`)
          !this.$v.postCode.maxLength && errors.push(`Максимум 6 цифр`)
        }
      }

      return errors
    },
    isAllowPostPackageCreate() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePostPackage
      })
    },
  },
  validations: {
    postCode: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  methods: {
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },
    onCourierChanged() {
      if (this.isCourierSelected) {
        this.postCode = '100000'
      }
    },

    onCreateClicked() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        let regionId = 0
        const postCodeFirstTwoChars = this.postCode.substr(0, 2)
        switch (postCodeFirstTwoChars) {
          case '10':
            regionId = 1;
            break;  // г.Ташкент
          case '11':
            regionId = 2;
            break;  // Ташкентская область
          case '14':
            regionId = 3;
            break;  // Самарканд
          case '13':
            regionId = 4;
            break;  // Жиззах
          case '12':
            regionId = 5;
            break;  // Сирдарё
          case '15':
            regionId = 6;
            break;  // Фаргона
          case '17':
            regionId = 7;
            break;  // Андижон
          case '16':
            regionId = 8;
            break;  // Наманган
          case '18':
            regionId = 9;
            break;  // Кашакадарё
          case '19':
            regionId = 10;
            break; // Сурхондарё
          case '20':
            regionId = 11;
            break; // Бухоро
          case '21':
            regionId = 12;
            break; // Навоий
          case '23':
            regionId = 13;
            break; // Коракалпогистон
          case '22':
            regionId = 14;
            break; // Хоразм
        }
        const region = _.find(this.$store.getters.appRegions, r => {
          return r.id === regionId
        })

        this.isRegionError = false
        this.isCreationFailed = false
        if (region) {
          this.loading = true
          this.$store.dispatch(LAYOUT_LOADING_START)
          PostPackageService.create({
            region: region,
            postCode: this.postCode,
            client: this.$store.getters.appActiveClient,
            courier: this.courier ? this.courier : null
          })
              .then(response => {
                const postPackage = Mappers.mapPostPackage(response.data)
                this.$router.push({name: 'post-package-set-mails', params: {uid: postPackage.uid}})
              })
              .catch((error) => {
                if (error) {

                  if (error.response.status === 401)
                    this.hasNotAccessToRegion = true

                  if (error.response.status === 409) {
                    if (error.response.data) {
                      if (!error.response.data.CreatingPostPackageAllowed) {
                        this.isCreationFailed = true
                      }
                      else if (!error.response.data.IsExists) {
                        this.isPostIndexNotExists = true
                      }
                      else if (!error.response.data.IsActive) {
                        this.isPostIndexNotActive = true
                      }
                    }
                  }
                }

              })
              .finally(() => {
                this.loading = false
                this.$store.dispatch(LAYOUT_LOADING_STOP)
              })
        } else {
          this.isRegionError = true
        }
      }
    }
  },
  created() {
    if (this.isAllowPostPackageCreate) {
      this.setPageTitle()

      if (this.$store.getters.appIsOperatorLogin) {
        this.postCode = this.$store.getters.appLogin.postIndex
      }
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
